import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { company } from '~/company/Company';
import { ModalType } from '~/components/Modal/interface';
import { REDIRECT_QUERY_NAME } from '~/components/ModalDeliveryAddress/constants';
import { useModal } from '~/hooks/useModal';
import { cartStore, userStore } from '~/stores';
import { getAddressModalType } from '~/utils/addressModal';

interface UseNavigateCartProps {
  source?: string;
  withReplace?: boolean;
  beforeNavigate?: () => void;
  afterNavigate?: () => void;
}

const useNavigateCart = (props?: UseNavigateCartProps) => {
  const { beforeNavigate, afterNavigate, source, withReplace } = props || {};
  const navigate = useNavigate();
  const { openModal } = useModal();

  return useCallback(() => {
    const addressModal = getAddressModalType();

    if (
      company.hasAgeRestriction &&
      userStore.isAuthorized &&
      !userStore.personalData.dateOfBirth &&
      cartStore.hasRestrictedCategoriesInCart
    ) {
      openModal(ModalType.BirthDate, source, {
        [REDIRECT_QUERY_NAME]: '/cart',
      });

      return;
    }

    if (!userStore.deliveryAddress) {
      openModal(addressModal, source, {
        [REDIRECT_QUERY_NAME]: '/cart',
      });
      return;
    }

    beforeNavigate?.();
    navigate('/cart', { replace: withReplace });
    afterNavigate?.();
  }, [beforeNavigate, afterNavigate, source, navigate, openModal]);
};

export default useNavigateCart;
